export const SEARCH_RESULTS_BASE_URL =
  "https://business.vic.gov.au/search-results";

export const FUNNELBACK_SUGGEST_BASE_URL =
  "https://djsir-search.funnelback.squiz.cloud/s/suggest.json";

export const SEARCH_SUGGEST_MIN_CHARS = 3;

export const SEARCH_SUGGEST_MAX_RESULTS = 6;

export function buildSearchResultsUrl(query) {
  return `${SEARCH_RESULTS_BASE_URL}?query=${encodeURIComponent(query)}`;
}

export function buildSuggestUrl(partialQuery) {
  const params = new URLSearchParams({
    collection: "djsir~sp-business-victoria",
    show: String(SEARCH_SUGGEST_MAX_RESULTS),
    sort: "0",
    alpha: ".5",
    fmt: "json++",
    partial_query: partialQuery
  });
  return `${FUNNELBACK_SUGGEST_BASE_URL}?${params.toString()}`;
}
